import { useMemo, useState } from "react";

interface PaginationFilters {
  linesPerPage: string;
  page: number;
  orderBy?: string;
  direction?: string;
}

const useFilterHandler = <T extends object>() => {
  const [paginationFilters, setPaginationFilters] = useState<PaginationFilters>(
    { orderBy: "id", direction: "DESC", linesPerPage: "10", page: 0 }
  );

  const [bodyFilters, setBodyFilters] = useState<any>({});
  const [filterOptions, setFilterOptions] = useState<any>({});
  const handleLinesPerPage = (linesPerPage: string) => {
    setPaginationFilters((prevFilters) => ({
      ...prevFilters,
      linesPerPage,
      page: 0,
    }));
  };

  const handleChangeOrder = (order: { orderBy: string; direction: string }) => {
    setPaginationFilters((prevFilters) => ({
      ...prevFilters,
      orderBy: order.orderBy,
      direction: order.direction,
    }));
  };

  const handlePageChange = (value: number) => {
    setPaginationFilters((prevFilters) => ({
      ...prevFilters,
      page: value,
    }));
  };

  const handleChangeBodyFilter = (prop: string, value: any) => {
    setBodyFilters((prevFilters: any) => ({
      ...prevFilters,
      [prop]: value,
    }));
  };

  const handleResetBodyFilters = () => {
    setBodyFilters({});
  };

  const handleSearchChange = (event: any, oqueVocePrecisa?: boolean) => {
    const value = event?.target?.value ?? event;

    if (oqueVocePrecisa) {
      setBodyFilters({
        oqueVocePrecisa: value,
      });
    } else {
      setBodyFilters({
        oqueVoceProcura: value,
      });
    }

    setPaginationFilters((prevState) => ({
      ...prevState,
      page: 0,
    }));
  };

  const handleGerencialFilters = (filters: any) => {
    setBodyFilters((prevFilters: any) => ({
      ...prevFilters,
      ...filters,
    }));
    setPaginationFilters((prevFilters) => ({
      ...prevFilters,
      page: 0,
    }));
  };

  return useMemo(
    () => ({
      filterOptions,
      setFilterOptions,
      paginationFilters,
      setPaginationFilters,
      bodyFilters,
      handleChangeBodyFilter,
      handleResetBodyFilters,
      handleLinesPerPage,
      handleChangeOrder,
      handlePageChange,
      handleSearchChange,
      handleGerencialFilters,
    }),
    [filterOptions, paginationFilters, bodyFilters]
  );
};

export default useFilterHandler;
